module.exports = __webpack_public_path__ + "static/img/zXyYYyYw.ceca61e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/horse-nest/zXyYYyYw.jpg
// module id = P/JZ
// module chunks = 7